__turbopack_context__.v({
  "wrapper": "CallToActionStackedSliderBlock-module-scss-module__8bcWGG__wrapper",
});
